<template>
  <v-container fluid fill-height class="pt-2">
    <v-layout row align-center justify-center>
      <v-card max-width="1280" width="100%" flat>
        <!-- Contrat Form Title -->
        <v-layout align-center row wrap v-if="isNewContract">
          <v-flex class="text-xs-center pt-4">
            <h3 class="grey--text text--darken-2">
              {{
                isNewContract
                  ? "New Contract Wizard"
                  : contract_draft.contract_name
              }}
            </h3>
            <v-label>
              {{
                contract_draft.supplier_company_short_name
                  ? contract_draft.supplier_company_short_name
                  : "-----"
              }}
              <v-icon size="14">mdi-arrow-right-bold</v-icon>
              {{
                contract_draft.customer_company_short_name
                  ? contract_draft.customer_company_short_name
                  : "-----"
              }}
            </v-label>
          </v-flex>
        </v-layout>

        <template v-if="!isNewContract && !editContract && !loading_query">
          <v-layout wrap row class="pt-0 pb-0">
            <!-- Buying Subsidiary -->
            <v-flex xs6 md4 px-2 py-2 d-flex order-md1 order-xs2>
              <v-card
                width="100%"
                class="elevation-2"
                v-if="buyingSubsidiary"
                :to="{
                  name: 'company',
                  params: { id: buyingSubsidiary.id },
                }"
              >
                <v-card-title class="pb-2 pt-2">
                  <span class="primary--text">Buying Subsidiary</span>
                </v-card-title>

                <v-card-text class="pt-0">
                  <h4 class="truncated-text">
                    <flag
                      style="
                        font-size: 10px;
                        position: relative;
                        top: -1px;
                        margin-right: 4px;
                      "
                      :iso="buyingSubsidiary.country.iso_code"
                    />
                    {{ buyingSubsidiary && buyingSubsidiary.name }}
                  </h4>

                  <v-label>
                    <v-icon size="14" class="pr-1">mdi-bank-transfer-out</v-icon
                    >Bank:
                    <b>
                      {{
                        buyingBankInformations.find(
                          (bi) =>
                            bi.id ==
                            this.contract_draft
                              .contract_buying_bank_information_id
                        ).name
                      }}
                    </b>
                  </v-label>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs12 md4 xs4 py-2 px-2 d-flex order-xs1>
              <v-card class="elevation-2" dark color="blue">
                <v-card-title class="pb-1 pt-2">
                  <span class="white--text"
                    ><v-icon small>event</v-icon>
                    {{ friendlyDate(this.contract_draft.contract_date) }}</span
                  >
                  <v-spacer></v-spacer>
                  <v-chip class="px-1 mr-0" light color="white"
                    ><v-icon
                      class="pr-1"
                      :color="editedContractStatusIconColor"
                      size="12"
                      >{{ editedContractStatusIcon }}</v-icon
                    >
                    <span style="font-size: 10px; color: #444">{{
                      editedContractStatus
                    }}</span>
                  </v-chip>
                </v-card-title>

                <v-card-text class="pt-0">
                  <v-layout row justify-center align-center>
                    <v-flex xs7>
                      <v-label dark>Contract Name</v-label>
                      <br />
                      <span class="title">{{
                        this.contract_draft.contract_name
                      }}</span>
                    </v-flex>

                    <v-flex xs5 justify-center align-end class="text-xs-right">
                      <v-label dark>Score Currency</v-label>
                      <br />
                      <span class="title">{{
                        this.editedContract.score_currency.code
                      }}</span>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>

            <!-- Selling Subsidiary -->
            <v-flex xs6 md4 px-2 py-2 d-flex order-xs3>
              <v-card
                width="100%"
                class="elevation-2"
                v-if="sellingSubsidiary"
                :to="{
                  name: 'company',
                  params: { id: sellingSubsidiary.id },
                }"
              >
                <v-card-title class="pb-2 pt-2">
                  <span class="primary--text">Selling Subsidiary</span>
                </v-card-title>

                <v-card-text class="pt-0">
                  <!-- SUPPLIER NAME -->
                  <h4 class="truncated-text">
                    <flag
                      style="
                        font-size: 10px;
                        position: relative;
                        top: -1px;
                        margin-right: 4px;
                      "
                      :iso="sellingSubsidiary.country.iso_code"
                    />
                    {{ sellingSubsidiary && sellingSubsidiary.name }}
                  </h4>

                  <v-label>
                    <v-icon size="14" class="pr-1">mdi-bank-transfer-in</v-icon
                    >Bank:
                    <b>
                      {{
                        sellingBankInformations.find(
                          (bi) =>
                            bi.id ==
                            this.contract_draft
                              .contract_selling_bank_information_id
                        ).name
                      }}
                    </b>
                  </v-label>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>

          <v-layout wrap row class="pt-0 pb-0">
            <!-- Product Supplier-->
            <v-flex xs12 sm12 md6 d-flex px-2 py-2>
              <v-card width="100%" class="elevation-2">
                <v-card-title class="pb-2 pt-2">
                  <span class="primary--text">Product Supplier</span>
                </v-card-title>

                <v-card-text class="pt-0">
                  <!-- SUPPLIER NAME -->
                  <h4 class="truncated-text">
                    <flag
                      style="
                        font-size: 10px;
                        position: relative;
                        top: -1px;
                        margin-right: 4px;
                      "
                      :iso="
                        editedContract.supplier_affiliate_company &&
                        editedContract.supplier_affiliate_company.country
                          ? editedContract.supplier_affiliate_company.country
                              .iso_code
                          : editedContract.supplier_company.country.iso_code
                      "
                    />

                    {{ supplierCompanyDisplayName }}
                  </h4>

                  <v-label>
                    <v-icon size="14" class="pr-1">mdi-cash</v-icon>Currency:
                    <b
                      v-if="
                        this.contract_draft.supplier &&
                        this.contract_draft.supplier.currencies
                      "
                    >
                      {{
                        this.contract_draft.supplier.currencies.find(
                          (c) =>
                            c.id == this.contract_draft.supplier_currency_id
                        ).code
                      }}
                    </b>
                  </v-label>
                  <br />

                  <v-label>
                    <v-icon size="14" class="pr-1">mdi-cash-check</v-icon
                    >Payment Terms:
                    <b
                      v-if="
                        this.contract_draft.supplier &&
                        this.contract_draft.supplier.payment_terms.length
                      "
                    >
                      {{
                        this.contract_draft.supplier.payment_terms.find(
                          (pt) =>
                            pt.id ==
                            this.contract_draft.supplier_payment_term_id
                        ).name
                      }}</b
                    >
                  </v-label>
                  <br />

                  <v-label>
                    <v-icon size="14" class="pr-1">mdi-comment-check</v-icon
                    >Incoterms:
                    <b
                      v-if="
                        this.contract_draft.supplier &&
                        this.contract_draft.supplier.incoterms.length
                      "
                    >
                      {{
                        this.contract_draft.supplier.incoterms.find(
                          (i) =>
                            i.id == this.contract_draft.supplier_incoterm_id
                        ).name
                      }}</b
                    >
                  </v-label>
                </v-card-text>
              </v-card>
            </v-flex>

            <!-- Customer -->
            <v-flex xs12 sm12 md6 px-2 d-flex py-2>
              <v-card width="100%" class="elevation-2">
                <v-card-title class="pb-2 pt-2">
                  <span class="primary--text">Customer</span>
                </v-card-title>

                <v-card-text class="pt-2">
                  <!-- Customer NAME -->
                  <h4 class="truncated-text">
                    <flag
                      style="
                        font-size: 10px;
                        position: relative;
                        top: -1px;
                        margin-right: 4px;
                      "
                      :iso="
                        editedContract.customer_affiliate_company &&
                        editedContract.customer_affiliate_company.country
                          ? editedContract.customer_affiliate_company.country
                              .iso_code
                          : editedContract.customer_company.country.iso_code
                      "
                    />

                    {{ contract_draft.customer_company_name }}
                  </h4>

                  <v-label>
                    <v-icon size="14" class="pr-1">mdi-cash</v-icon>Currency:
                    <b
                      v-if="
                        this.contract_draft.customer &&
                        this.contract_draft.customer.currencies
                      "
                    >
                      {{
                        this.contract_draft.customer.currencies.find(
                          (c) =>
                            c.id == this.contract_draft.customer_currency_id
                        ).code
                      }}</b
                    >
                  </v-label>
                  <br />

                  <v-label>
                    <v-icon size="14" class="pr-1">mdi-cash-check</v-icon
                    >Payment Terms:
                    <b
                      v-if="
                        this.contract_draft.customer &&
                        this.contract_draft.customer.payment_terms
                      "
                    >
                      {{
                        this.contract_draft.customer.payment_terms.find(
                          (pt) =>
                            pt.id ==
                            this.contract_draft.customer_payment_term_id
                        ).name
                      }}</b
                    >
                  </v-label>
                  <br />

                  <v-label>
                    <v-icon size="14" class="pr-1">mdi-comment-check</v-icon
                    >Incoterms:
                    <b
                      v-if="
                        this.contract_draft.customer &&
                        this.contract_draft.customer.incoterms
                      "
                    >
                      {{
                        this.contract_draft.customer.incoterms.find(
                          (i) =>
                            i.id == this.contract_draft.customer_incoterm_id
                        ).name
                      }}</b
                    > </v-label
                  ><br />

                  <v-label>
                    <v-icon size="14" class="pr-1">mdi-text-box-check</v-icon
                    >Documentary Instructions:
                    <b
                      v-if="
                        this.contract_draft.customer &&
                        this.contract_draft.customer.documentary_instructions && this.contract_draft.customer.documentary_instructions.find(
                          (di) =>
                            di.id ==
                            this.contract_draft
                              .customer_documentary_instruction_id
                        )
                      "
                      >{{
                        this.contract_draft.customer.documentary_instructions.find(
                          (di) =>
                            di.id ==
                            this.contract_draft
                              .customer_documentary_instruction_id
                        ).name
                      }}</b
                    >
                  </v-label>
                  <br />

                  <v-label>
                    <v-icon size="14" class="pr-1">mdi-clipboard-search</v-icon
                    >Logistic Auditor:
                    <b
                      v-if="
                        this.contract_draft.customer &&
                        this.contract_draft.customer.logistic_auditors.length
                      "
                    >
                      {{
                        this.contract_draft.customer_logistic_auditor_id
                          ? this.contract_draft.customer.logistic_auditors.find(
                              (a) =>
                                a.id ==
                                this.contract_draft.customer_logistic_auditor_id
                            ).name
                          : "----"
                      }}</b
                    >
                  </v-label>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>

          <v-layout wrap row class="pt-0 pb-2">
            <!-- Loading-->
            <v-flex xs12 sm12 md6 px-2 d-flex py-2>
              <v-card width="100%" class="elevation-2">
                <v-card-title class="pb-2 pt-2">
                  <span class="primary--text">Shipment Loading</span>
                </v-card-title>

                <v-card-text class="pt-2" v-if="this.contract_draft.supplier">
                  <!-- SUPPLIER NAME -->

                  <v-label>
                    <v-icon size="14" class="pr-1"
                      >mdi-boom-gate-down-outline</v-icon
                    >POL (Port Of Loading):
                    <b v-if="this.contract_draft.supplier.ports">
                      {{
                        this.contract_draft.supplier.ports.find(
                          (p) =>
                            p.id == this.contract_draft.contract_loading_port_id
                        ).name
                      }}
                    </b>
                  </v-label>
                  <br />

                  <v-label>
                    <v-icon size="14" class="pr-1">mdi-flag</v-icon> Products
                    Origin Country:
                    <b>
                      <flag
                        v-if="
                          this.contract_draft.supplier &&
                          this.contract_draft.supplier.countries
                        "
                        style="
                          font-size: 10px;
                          position: relative;
                          top: -1px;
                          margin-right: 4px;
                        "
                        :iso="
                          this.contract_draft.supplier.countries.find(
                            (c) =>
                              c.id ==
                              this.contract_draft.contract_origin_country_id
                          ).iso_code
                        "
                      />
                      {{
                        this.contract_draft.supplier.countries.find(
                          (c) =>
                            c.id ==
                            this.contract_draft.contract_origin_country_id
                        ).name
                      }}
                    </b>
                  </v-label>
                  <br />

                  <v-label>
                    <v-icon size="14" class="pr-1">event</v-icon>For Supplier:
                    Departure Date:
                    <b>
                      {{
                        this.timeToDate(
                          this.contract_draft.contract_loading_departure_date
                        )
                      }}
                    </b>
                  </v-label>
                  <br />

                  <v-label>
                    <v-icon size="14" class="pr-1">event</v-icon>For Supplier:
                    Arrival Date:
                    <b>
                      {{
                        this.timeToDate(
                          this.contract_draft.contract_loading_arrival_date
                        )
                      }}
                    </b>
                  </v-label>
                </v-card-text>
              </v-card>
            </v-flex>

            <!-- Unloading -->
            <v-flex xs12 sm12 md6 px-2 d-flex py-2>
              <v-card width="100%" class="elevation-2">
                <v-card-title class="pb-2 pt-2">
                  <span class="primary--text">Shipment Unloading</span>
                </v-card-title>

                <v-card-text class="pt-2" v-if="this.contract_draft.customer">
                  <v-label>
                    <v-icon size="14" class="pr-1"
                      >mdi-boom-gate-up-outline</v-icon
                    >POU (Port Of Unloading):
                    <b v-if="this.contract_draft.customer.ports">
                      {{
                        this.contract_draft.customer.ports.find(
                          (p) =>
                            p.id ==
                            this.contract_draft.contract_unloading_port_id
                        ).name
                      }}
                    </b>
                  </v-label>
                  <br />

                  <v-label>
                    <v-icon size="14" class="pr-1">mdi-flag</v-icon> Products
                    Destination Country:
                    <b>
                      <flag
                        v-if="
                          this.contract_draft.customer &&
                          this.contract_draft.customer.countries
                        "
                        style="
                          font-size: 10px;
                          position: relative;
                          top: -1px;
                          margin-right: 4px;
                        "
                        :iso="
                          this.contract_draft.customer.countries.find(
                            (c) =>
                              c.id ==
                              this.contract_draft
                                .contract_destination_country_id
                          ).iso_code
                        "
                      />
                      {{
                        this.contract_draft.customer.countries.find(
                          (c) =>
                            c.id ==
                            this.contract_draft.contract_destination_country_id
                        ).name
                      }}
                    </b>
                  </v-label>
                  <br />

                  <v-label>
                    <v-icon size="14" class="pr-1">event</v-icon>For Customer:
                    Departure Date:
                    <b>
                      {{
                        this.timeToDate(
                          this.contract_draft.contract_unloading_departure_date
                        )
                      }}
                    </b>
                  </v-label>

                   <v-tooltip color="info" bottom v-if="this.timeToDate(this.contract_draft.contract_unloading_departure_date) != this.timeToDate(this.contract_draft.contract_loading_departure_date)">
                    <template v-slot:activator="{ on }">
                      <v-icon small color="info" dark v-on="on">info</v-icon>
                    </template>
                    <span><b>Customer Departure Date</b> has a different value than <b>Supplier Departure Date</b></span>
                  </v-tooltip>
                  <br />

                  <v-label>
                    <v-icon size="14" class="pr-1">event</v-icon>For Customer:
                    Arrival Date:
                    <b>
                      {{
                        this.timeToDate(
                          this.contract_draft.contract_unloading_arrival_date
                        )
                      }}
                    </b>
                  </v-label>

                  <v-tooltip color="info" bottom v-if="this.timeToDate(this.contract_draft.contract_unloading_arrival_date) != this.timeToDate(this.contract_draft.contract_loading_arrival_date)">
                    <template v-slot:activator="{ on }">
                      <v-icon small color="info" dark v-on="on">info</v-icon>
                    </template>
                    <span><b>Customer Arrival Date</b> has a different value than <b>Supplier Arrival Date</b></span>
                  </v-tooltip>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </template>

        <!-- Stepper -->
        <v-stepper
          alt-labels
          v-model="step"
          v-show="isNewContract || editContract"
        >
          <!-- Headers -->
          <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1"
              >Contract Settings</v-stepper-step
            >

            <v-divider></v-divider>

            <v-stepper-step :complete="step > 2" step="2"
              >Subsidiaries</v-stepper-step
            >

            <v-divider></v-divider>

            <v-stepper-step :complete="step > 3" step="3"
              >Supplier/Customer</v-stepper-step
            >

            <v-divider></v-divider>

            <v-stepper-step :complete="step > 4" step="4"
              >Loading/Unloading</v-stepper-step
            >

            <v-divider></v-divider>

            <v-stepper-step step="5">Validation</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <!-- Contract Name - Date - Score Currency -->
            <v-stepper-content step="1">
              <v-layout row wrap align-center justify-center class="pb-4">
                <!-- Step Title -->
                <v-flex xs12 class="pa-4 text-xs-center">
                  <span class="caption grey--text text--darken-1">
                    Please fill the <strong>NAME</strong>, the
                    <strong>DATE</strong> and the
                    <strong>SCORE CURRENCY</strong> fields.
                  </span>
                </v-flex>

                <!-- Contract Name -->
                <v-flex xs12 sm6 md4 offset-3>
                  <v-text-field
                    v-model="contract_draft.contract_name"
                    label="Contract Name"
                    background-color="white"
                    hide-details
                  >
                    <template slot="label">
                      <v-icon size="14" class="pr-1" color="#757575"
                        >mdi-format-quote-close</v-icon
                      >Contract Name
                    </template>
                  </v-text-field>
                </v-flex>

                <v-flex xs12></v-flex>

                <!-- Contract Date -->
                <v-flex xs12 sm6 md4 offset-3 class="pt-4">
                  <v-menu
                    ref="contract_date_menu"
                    :close-on-content-click="true"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      readonly
                      slot="activator"
                      :value="
                        contract_draft.contract_date
                          ? timeToDate(contract_draft.contract_date)
                          : null
                      "
                      hide-details
                      label="Contract Date"
                    >
                      <template slot="label">
                        <v-icon size="14" class="pr-1" color="#757575"
                          >event</v-icon
                        >Contract Date
                      </template>
                    </v-text-field>
                    <v-date-picker
                      v-model="contract_draft.contract_date"
                      no-title
                      scrollable
                      first-day-of-week="1"
                    />
                  </v-menu>
                </v-flex>

                <v-flex xs12></v-flex>

                <!-- Score Currency -->
                <v-flex xs12 sm6 md4 offset-3 class="py-4">
                  <v-autocomplete
                    :items="currencies"
                    item-value="id"
                    item-text="code"
                    v-model="contract_draft.contract_score_currency_id"
                    background-color="white"
                    browser-autocomplete="noautocomplete"
                    hide-details
                    label="Score Currency"
                  >
                    <template slot="label">
                      <v-icon size="14" class="pr-1" color="#757575"
                        >money</v-icon
                      >
                      Score Currency
                    </template>
                  </v-autocomplete>
                </v-flex>
              </v-layout>
            </v-stepper-content>

            <!-- Subsidiaries-->
            <v-stepper-content step="2">
              <v-layout row wrap justify-center class="pb-4">
                <!-- Step Title -->
                <v-flex xs12 class="pa-4 text-xs-center">
                  <span class="caption grey--text text--darken-1">
                    Please fill <strong>BUYING</strong> and
                    <strong>SELLING</strong> subsidiaries settings.
                  </span>
                </v-flex>

                <!-- Buying Subsidiaries -->
                <v-flex xs5>
                  <v-layout row wrap justify-center class="pb-4">
                    <v-flex xs12 class="text-xs-center">
                      <span class="grey--text text--darken-1 font-weight-bold"
                        >Buying Subsidiary</span
                      >
                    </v-flex>

                    <!-- Subsidiary-->
                    <v-flex xs12>
                      <v-autocomplete
                        dense
                        :items="subsidiaries"
                        item-value="id"
                        item-text="name"
                        background-color="white"
                        browser-autocomplete="noautocomplete"
                        label="Buying Subsidiary"
                        v-model="contract_draft.contract_buying_subsidiary_id"
                        @change="
                          contract_draft.contract_buying_bank_information_id =
                            ''
                        "
                      >
                        <template slot="label">
                          <v-icon size="14" class="pr-1" color="#757575"
                            >mdi-store</v-icon
                          >Buying Subsidiary
                        </template>
                      </v-autocomplete>
                    </v-flex>

                    <!-- Buying Bank Informations-->
                    <v-slide-y-transition>
                      <v-flex
                        xs12
                        v-show="contract_draft.contract_buying_subsidiary_id"
                      >
                        <v-autocomplete
                          dense
                          :items="buyingBankInformations"
                          item-value="id"
                          item-text="name"
                          background-color="white"
                          browser-autocomplete="noautocomplete"
                          label="Buying Bank Informations"
                          v-model="
                            contract_draft.contract_buying_bank_information_id
                          "
                        >
                          <template slot="label">
                            <v-icon size="14" class="pr-1" color="#757575"
                              >mdi-bank-transfer-out</v-icon
                            >Buying Bank Informations
                          </template>
                        </v-autocomplete>
                      </v-flex>
                    </v-slide-y-transition>
                  </v-layout>
                </v-flex>

                <!-- MIDDLE ARROW ICON -->
                <v-flex xs2>
                  <v-layout
                    row
                    wrap
                    fill-height
                    align-center
                    class="text-xs-center"
                  >
                    <v-flex xs12>
                      <v-icon size="36" color="success"
                        >mdi-transfer-right</v-icon
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
                <!-- Selling Subsidiaries -->
                <v-flex xs5>
                  <v-layout row wrap justify-center class="pb-4">
                    <v-flex xs12 class="text-xs-center">
                      <span class="grey--text text--darken-1 font-weight-bold"
                        >Selling Subsidiary</span
                      >
                    </v-flex>

                    <!-- Subsidiary-->
                    <v-flex xs12>
                      <v-autocomplete
                        dense
                        :items="subsidiaries"
                        item-value="id"
                        item-text="name"
                        background-color="white"
                        browser-autocomplete="noautocomplete"
                        label="Selling Subsidiary"
                        v-model="contract_draft.contract_selling_subsidiary_id"
                        @change="
                          contract_draft.contract_selling_bank_information_id =
                            ''
                        "
                      >
                        <template slot="label">
                          <v-icon size="14" class="pr-1" color="#757575"
                            >mdi-store</v-icon
                          >Selling Subsidiary
                        </template>
                      </v-autocomplete>
                    </v-flex>

                    <!-- Seeling Bank Informations-->
                    <v-slide-y-transition>
                      <v-flex
                        xs12
                        v-show="contract_draft.contract_selling_subsidiary_id"
                      >
                        <v-autocomplete
                          dense
                          :items="sellingBankInformations"
                          item-value="id"
                          item-text="name"
                          background-color="white"
                          browser-autocomplete="noautocomplete"
                          label="Selling Bank Informations"
                          v-model="
                            contract_draft.contract_selling_bank_information_id
                          "
                        >
                          <template slot="label">
                            <v-icon size="14" class="pr-1" color="#757575"
                              >mdi-bank-transfer-in</v-icon
                            >Selling Bank Informations
                          </template>
                        </v-autocomplete>
                      </v-flex>
                    </v-slide-y-transition>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-stepper-content>

            <!-- Customer Supplier -->
            <v-stepper-content step="3">
              <v-layout row wrap justify-center class="pb-4">
                <!-- Step Title -->
                <v-flex xs12 class="pa-4 text-xs-center">
                  <span class="caption grey--text text--darken-1">
                    Please fill <strong>SUPPLIER</strong> and
                    <strong>CUSTOMER</strong> settings.
                  </span>
                </v-flex>

                <!-- FROM -->
                <v-flex xs5>
                  <v-layout row wrap justify-center class="pb-4">
                    <v-flex xs12 class="text-xs-center">
                      <span class="grey--text text--darken-1 font-weight-bold"
                        >Supplier</span
                      >
                    </v-flex>

                    <!-- Supplier -->
                    <v-flex xs12>
                      <v-autocomplete
                        dense
                        :items="productsSupplierCompanies"
                        item-value="id"
                        item-text="name"
                        browser-autocomplete="noautocomplete"
                        label="To"
                        v-model="contract_draft.supplier_company_id"
                        @change="queryCompanyInfos('supplier')"
                      >
                        <template slot="label">
                          <v-icon size="14" class="pr-1" color="#757575"
                            >mdi-store</v-icon
                          >Products Supplier
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <template v-if="contract_draft.supplier_errors.length == 0">
                      <!-- Affiliate -->
                      <v-slide-y-transition>
                        <v-flex
                          xs12
                          v-show="contract_draft.supplier_company_id"
                        >
                          <v-autocomplete
                            dense
                            clearable
                            :items="supplierAffiliateCompanies"
                            item-value="id"
                            item-text="name"
                            browser-autocomplete="noautocomplete"
                            label="Affiliate Company"
                            v-model="contract_draft.supplier_affiliate_id"
                          >
                            <template slot="label">
                              <v-icon size="14" class="pr-1" color="#757575"
                                >mdi-store-outline</v-icon
                              >Supplier Affiliate
                            </template>

                            <template slot="no-data">
                              <v-list-tile>
                                <v-list-tile-title>
                                  No affiliate companies found
                                </v-list-tile-title>
                              </v-list-tile>
                            </template>
                          </v-autocomplete>
                        </v-flex>
                      </v-slide-y-transition>

                      <!-- Currency -->
                      <v-slide-y-transition>
                        <v-flex xs12 v-show="contract_draft.supplier">
                          <v-autocomplete
                            dense
                            v-if="contract_draft.supplier"
                            :items="contract_draft.supplier.currencies"
                            item-value="id"
                            item-text="code"
                            browser-autocomplete="noautocomplete"
                            label="Supplier Currency"
                            v-model="contract_draft.supplier_currency_id"
                          >
                            <template slot="label">
                              <v-icon size="14" class="pr-1" color="#757575"
                                >mdi-cash</v-icon
                              >Supplier Currency
                            </template>

                            <template slot="no-data">
                              <v-list-tile>
                                <v-list-tile-title>
                                  No currencies found
                                </v-list-tile-title>
                              </v-list-tile>
                            </template>
                          </v-autocomplete>
                        </v-flex>
                      </v-slide-y-transition>

                      <!-- Payment Term -->
                      <v-slide-y-transition>
                        <v-flex xs12 v-show="contract_draft.supplier">
                          <v-autocomplete
                            dense
                            v-if="contract_draft.supplier"
                            :items="contract_draft.supplier.payment_terms"
                            item-value="id"
                            item-text="name"
                            browser-autocomplete="noautocomplete"
                            label="Supplier Payment Terms"
                            v-model="contract_draft.supplier_payment_term_id"
                          >
                            <template slot="label">
                              <v-icon size="14" class="pr-1" color="#757575"
                                >mdi-cash-check</v-icon
                              >Supplier Payment Terms
                            </template>

                            <template slot="no-data">
                              <v-list-tile>
                                <v-list-tile-title>
                                  No Payment Terms found
                                </v-list-tile-title>
                              </v-list-tile>
                            </template>
                          </v-autocomplete>
                        </v-flex>
                      </v-slide-y-transition>

                      <!-- IncoTerm -->
                      <v-slide-y-transition>
                        <v-flex xs12 v-show="contract_draft.supplier">
                          <v-autocomplete
                            dense
                            v-if="contract_draft.supplier"
                            :items="contract_draft.supplier.incoterms"
                            item-value="id"
                            item-text="name"
                            browser-autocomplete="noautocomplete"
                            label="Supplier Incoterms"
                            v-model="contract_draft.supplier_incoterm_id"
                          >
                            <template slot="label">
                              <v-icon size="14" class="pr-1" color="#757575"
                                >mdi-comment-check</v-icon
                              >Supplier Incoterms
                            </template>

                            <template slot="no-data">
                              <v-list-tile>
                                <v-list-tile-title>
                                  No Incoterms found
                                </v-list-tile-title>
                              </v-list-tile>
                            </template>
                          </v-autocomplete>
                        </v-flex>
                      </v-slide-y-transition>
                    </template>

                    <template v-else>
                      <v-layout row wrap class="text-xs-left pb-2 pt-4">
                        <span>
                          <v-icon color="error" small class="pr-2"
                            >warning</v-icon
                          >This supplier cannot be used du to the following
                          reason(s):
                        </span>
                      </v-layout>

                      <v-flex
                        xs12
                        v-for="(error, index) in contract_draft.supplier_errors"
                        :key="'err_' + index"
                      >
                        <span class="caption" v-html="'- ' + error" />
                      </v-flex>

                      <v-layout row wrap align-center class="text-xs-left py-4">
                        <router-link
                          target="_blank"
                          class="pr-1 font-weight-bold"
                          :to="{
                            name: 'company',
                            params: { id: contract_draft.supplier_company_id },
                          }"
                          >Edit this supplier</router-link
                        >
                        and
                        <a
                          class="px-1 font-weight-bold"
                          style="text-decoration: underline"
                          @click="queryCompanyInfos('supplier')"
                          >Reload</a
                        >
                        or <b class="px-1"> select another one </b> to continue.
                      </v-layout>
                    </template>
                  </v-layout>
                </v-flex>

                <!-- MIDDLE ARROW ICON -->
                <v-flex xs2>
                  <v-layout
                    row
                    wrap
                    fill-height
                    align-center
                    class="text-xs-center"
                  >
                    <v-flex xs12>
                      <v-icon size="36" color="success"
                        >mdi-transfer-right</v-icon
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
                <!-- TO -->
                <v-flex xs5>
                  <v-layout row wrap justify-center class="pr-4 pb-4">
                    <v-flex xs12 class="text-xs-center">
                      <span class="grey--text text--darken-1 font-weight-bold"
                        >Customer</span
                      >
                    </v-flex>

                    <!-- Customer -->
                    <v-flex xs12>
                      <v-autocomplete
                        dense
                        :items="customers"
                        item-value="id"
                        item-text="name"
                        background-color="white"
                        browser-autocomplete="noautocomplete"
                        label="To"
                        v-model="contract_draft.customer_company_id"
                        @change="queryCompanyInfos('customer')"
                      >
                        <template slot="label">
                          <v-icon size="14" class="pr-1" color="#757575"
                            >mdi-store</v-icon
                          >Customer
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <template v-if="contract_draft.customer_errors.length == 0">
                      <!-- Affiliate -->
                      <v-slide-y-transition>
                        <v-flex
                          xs12
                          v-show="contract_draft.customer_company_id"
                        >
                          <v-autocomplete
                            clearable
                            dense
                            :items="customerAffiliateCompanies"
                            item-value="id"
                            item-text="name"
                            browser-autocomplete="noautocomplete"
                            label="Affiliate Company"
                            v-model="contract_draft.customer_affiliate_id"
                          >
                            <template slot="label">
                              <v-icon size="14" class="pr-1" color="#757575"
                                >mdi-store-outline</v-icon
                              >Customer Affiliate
                            </template>

                            <template slot="no-data">
                              <v-list-tile>
                                <v-list-tile-title>
                                  No affiliate companies found
                                </v-list-tile-title>
                              </v-list-tile>
                            </template>
                          </v-autocomplete>
                        </v-flex>
                      </v-slide-y-transition>

                      <!-- Currency -->
                      <v-slide-y-transition>
                        <v-flex xs12 v-show="contract_draft.customer">
                          <v-autocomplete
                            dense
                            v-if="contract_draft.customer"
                            :items="contract_draft.customer.currencies"
                            item-value="id"
                            item-text="code"
                            browser-autocomplete="noautocomplete"
                            label="Customer Currency"
                            v-model="contract_draft.customer_currency_id"
                          >
                            <template slot="label">
                              <v-icon size="14" class="pr-1" color="#757575"
                                >mdi-cash</v-icon
                              >Customer Currency
                            </template>

                            <template slot="no-data">
                              <v-list-tile>
                                <v-list-tile-title>
                                  No currencies found
                                </v-list-tile-title>
                              </v-list-tile>
                            </template>
                          </v-autocomplete>
                        </v-flex>
                      </v-slide-y-transition>

                      <!-- Payment Term -->
                      <v-slide-y-transition>
                        <v-flex xs12 v-show="contract_draft.customer">
                          <v-autocomplete
                            dense
                            v-if="contract_draft.customer"
                            :items="contract_draft.customer.payment_terms"
                            item-value="id"
                            item-text="name"
                            browser-autocomplete="noautocomplete"
                            label="Customer Payment Terms"
                            v-model="contract_draft.customer_payment_term_id"
                          >
                            <template slot="label">
                              <v-icon size="14" class="pr-1" color="#757575"
                                >mdi-cash-check</v-icon
                              >Customer Payment Terms
                            </template>

                            <template slot="no-data">
                              <v-list-tile>
                                <v-list-tile-title>
                                  No Payment Terms found
                                </v-list-tile-title>
                              </v-list-tile>
                            </template>
                          </v-autocomplete>
                        </v-flex>
                      </v-slide-y-transition>

                      <!-- IncoTerm -->
                      <v-slide-y-transition>
                        <v-flex xs12 v-show="contract_draft.customer">
                          <v-autocomplete
                            dense
                            v-if="contract_draft.customer"
                            :items="contract_draft.customer.incoterms"
                            item-value="id"
                            item-text="name"
                            browser-autocomplete="noautocomplete"
                            label="Customer Incoterms"
                            v-model="contract_draft.customer_incoterm_id"
                          >
                            <template slot="label">
                              <v-icon size="14" class="pr-1" color="#757575"
                                >mdi-comment-check</v-icon
                              >Customer Incoterms
                            </template>

                            <template slot="no-data">
                              <v-list-tile>
                                <v-list-tile-title>
                                  No Incoterms found
                                </v-list-tile-title>
                              </v-list-tile>
                            </template>
                          </v-autocomplete>
                        </v-flex>
                      </v-slide-y-transition>

                      <!-- Customer Documentary Instructions -->
                      <v-slide-y-transition>
                        <v-flex xs12 v-show="contract_draft.customer">
                          <v-autocomplete
                            dense
                            v-if="contract_draft.customer"
                            :items="
                              contract_draft.customer.documentary_instructions
                            "
                            item-value="id"
                            item-text="name"
                            browser-autocomplete="noautocomplete"
                            label="Customer Documentary Instructions"
                            v-model="
                              contract_draft.customer_documentary_instruction_id
                            "
                          >
                            <template slot="label">
                              <v-icon size="14" class="pr-1" color="#757575"
                                >mdi-text-box-check</v-icon
                              >Customer Documentary Instructions
                            </template>

                            <template slot="no-data">
                              <v-list-tile>
                                <v-list-tile-title>
                                  No Documentary Instructions found
                                </v-list-tile-title>
                              </v-list-tile>
                            </template>
                          </v-autocomplete>
                        </v-flex>
                      </v-slide-y-transition>

                      <!-- Customer Logistic Auditor -->
                      <v-slide-y-transition>
                        <v-flex xs12 v-show="contract_draft.customer">
                          <v-autocomplete
                            dense
                            v-if="contract_draft.customer"
                            :items="contract_draft.customer.logistic_auditors"
                            item-value="id"
                            item-text="name"
                            browser-autocomplete="noautocomplete"
                            label="Customer Logistic Auditor"
                            v-model="
                              contract_draft.customer_logistic_auditor_id
                            "
                            clearable
                          >
                            <template slot="label">
                              <v-icon size="14" class="pr-1" color="#757575"
                                >mdi-clipboard-search</v-icon
                              >Customer Logistic Auditor
                            </template>

                            <template slot="no-data">
                              <v-list-tile>
                                <v-list-tile-title>
                                  No Logistic Auditors found
                                </v-list-tile-title>
                              </v-list-tile>
                            </template>
                          </v-autocomplete>
                        </v-flex>
                      </v-slide-y-transition>
                    </template>

                    <template v-else>
                      <v-layout row wrap class="text-xs-left pb-2 pt-4">
                        <span>
                          <v-icon color="error" small class="pr-2"
                            >warning</v-icon
                          >This customer cannot be used du to the following
                          reason(s):
                        </span>
                      </v-layout>

                      <v-flex
                        xs12
                        v-for="(error, index) in contract_draft.customer_errors"
                        :key="'err_' + index"
                      >
                        <span class="caption" v-html="'- ' + error" />
                      </v-flex>

                      <v-layout row wrap align-center class="text-xs-left py-4">
                        <router-link
                          target="_blank"
                          class="pr-1 font-weight-bold"
                          :to="{
                            name: 'company',
                            params: { id: contract_draft.customer_company_id },
                          }"
                          >Edit this customer</router-link
                        >
                        and
                        <a
                          class="px-1 font-weight-bold"
                          style="text-decoration: underline"
                          @click="queryCompanyInfos('customer')"
                          >Reload</a
                        >
                        or <b class="px-1"> select another one </b> to continue.
                      </v-layout>
                    </template>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-stepper-content>

            <!-- Loading / Unloading -->
            <v-stepper-content step="4">
              <v-layout
                row
                wrap
                justify-center
                class="pb-4"
                v-if="this.step == 4"
              >
                <!-- Step Title -->
                <v-flex xs12 class="pa-4 text-xs-center">
                  <span class="caption grey--text text--darken-1">
                    Please fill <strong>LOADING</strong> and
                    <strong>UNLOADING</strong> settings.
                  </span>
                </v-flex>

                <!-- Loading -->
                <v-flex xs5>
                  <v-layout row wrap justify-center class="pb-4">
                    <v-flex xs12 class="text-xs-center">
                      <span class="grey--text text--darken-1 font-weight-bold"
                        >Loading</span
                      >
                    </v-flex>

                    <!-- Port Of Loading -->
                    <v-flex xs12>
                      <v-autocomplete
                        dense
                        :items="contract_draft.supplier.ports"
                        item-value="id"
                        item-text="name"
                        background-color="white"
                        browser-autocomplete="noautocomplete"
                        label="To"
                        v-model="contract_draft.contract_loading_port_id"
                        v-if="contract_draft.supplier"
                      >
                        <template slot="label">
                          <v-icon size="14" class="pr-1" color="#757575"
                            >mdi-boom-gate-down-outline</v-icon
                          >POL (Port Of Loading)
                        </template>
                      </v-autocomplete>
                    </v-flex>

                    <!-- Country of Origin -->
                    <v-flex xs12>
                      <v-autocomplete
                        dense
                        :items="contract_draft.supplier.countries"
                        item-value="id"
                        item-text="name"
                        background-color="white"
                        browser-autocomplete="noautocomplete"
                        label="To"
                        v-model="contract_draft.contract_origin_country_id"
                        v-if="contract_draft.supplier"
                      >
                        <template slot="label">
                          <v-icon
                            v-if="!contract_draft.contract_origin_country_id"
                            size="14"
                            class="pr-1"
                            color="#757575"
                            >mdi-boom-gate-down-outline</v-icon
                          >
                          <flag
                            class="pl-0 mr-1"
                            v-else
                            :iso="
                              contract_draft.supplier.countries.find(
                                (c) =>
                                  c.id ==
                                  contract_draft.contract_origin_country_id
                              ).iso_code
                            "
                          />
                          Products Origin Country
                        </template>
                      </v-autocomplete>
                    </v-flex>

                    <!-- Departure date -->
                    <v-flex xs12>
                      <v-menu
                        ref="contract_loading_departure_date"
                        :close-on-content-click="true"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <v-text-field
                          readonly
                          slot="activator"
                          :value="
                            contract_draft.contract_loading_departure_date
                              ? timeToDate(
                                  contract_draft.contract_loading_departure_date
                                )
                              : null
                          "
                          label="Loading Departure Date"
                        >
                          <template slot="label">
                            <v-icon size="14" class="pr-1" color="#757575"
                              >event</v-icon
                            >For Supplier: Departure Date
                          </template>
                        </v-text-field>
                        <v-date-picker
                          v-model="
                            contract_draft.contract_loading_departure_date
                          "
                          no-title
                          scrollable
                          first-day-of-week="1"
                        />
                      </v-menu>
                    </v-flex>

                    <!-- Arrival  date -->
                    <v-flex xs12>
                      <v-menu
                        ref="contract_loading_arrival_date"
                        :close-on-content-click="true"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <v-text-field
                          readonly
                          slot="activator"
                          :value="
                            contract_draft.contract_loading_arrival_date
                              ? timeToDate(
                                  contract_draft.contract_loading_arrival_date
                                )
                              : null
                          "
                          label="Loading Arrival Date"
                        >
                          <template slot="label">
                            <v-icon size="14" class="pr-1" color="#757575"
                              >event</v-icon
                            >For Supplier: Arrival Date
                          </template>
                        </v-text-field>
                        <v-date-picker
                          v-model="contract_draft.contract_loading_arrival_date"
                          no-title
                          scrollable
                          first-day-of-week="1"
                        />
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <!-- MIDDLE ARROW ICON -->
                <v-flex xs2>
                  <v-layout
                    row
                    wrap
                    fill-height
                    align-center
                    class="text-xs-center"
                  >
                    <v-flex xs12>
                      <v-icon size="36" color="success"
                        >mdi-transfer-right</v-icon
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
                <!-- Unloading -->
                <v-flex xs5>
                  <v-layout row wrap justify-center class="pr-4 pb-4">
                    <v-flex xs12 class="text-xs-center">
                      <span class="grey--text text--darken-1 font-weight-bold"
                        >Unloading</span
                      >
                    </v-flex>

                    <!-- Port Of Unloading -->
                    <v-flex xs12>
                      <v-autocomplete
                        dense
                        :items="contract_draft.customer.ports"
                        item-value="id"
                        item-text="name"
                        background-color="white"
                        browser-autocomplete="noautocomplete"
                        label="To"
                        v-model="contract_draft.contract_unloading_port_id"
                        v-if="contract_draft.customer"
                      >
                        <template slot="label">
                          <v-icon size="14" class="pr-1" color="#757575"
                            >mdi-boom-gate-down-outline</v-icon
                          >POU (Port Of Unloading)
                        </template>
                      </v-autocomplete>
                    </v-flex>

                    <!-- Country of Unloading -->
                    <v-flex xs12>
                      <v-autocomplete
                        dense
                        :items="contract_draft.customer.countries"
                        item-value="id"
                        item-text="name"
                        background-color="white"
                        browser-autocomplete="noautocomplete"
                        label="To"
                        v-model="contract_draft.contract_destination_country_id"
                        v-if="contract_draft.customer"
                      >
                        <template slot="label">
                          <v-icon
                            v-if="
                              !contract_draft.contract_destination_country_id
                            "
                            size="14"
                            class="pr-1"
                            color="#757575"
                            >mdi-boom-gate-up-outline</v-icon
                          >
                          <flag
                            class="pl-0 mr-1"
                            v-else
                            :iso="
                              contract_draft.customer.countries.find(
                                (c) =>
                                  c.id ==
                                  contract_draft.contract_destination_country_id
                              ).iso_code
                            "
                          />
                          Products Destination Country
                        </template>
                      </v-autocomplete>
                    </v-flex>

                    <!-- Departure date -->
                    <v-flex xs12>
                      <v-menu
                        ref="contract_unloading_departure_date"
                        :close-on-content-click="true"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <v-text-field
                          readonly
                          slot="activator"
                          :value="
                            contract_draft.contract_unloading_departure_date
                              ? timeToDate(
                                  contract_draft.contract_unloading_departure_date
                                )
                              : null
                          "
                          label="Unloading Departure Date"
                        >
                          <template slot="label">
                            <v-icon size="14" class="pr-1" color="#757575"
                              >event</v-icon
                            >For Customer: Departure Date
                          </template>
                        </v-text-field>
                        <v-date-picker
                          v-model="
                            contract_draft.contract_unloading_departure_date
                          "
                          no-title
                          scrollable
                          first-day-of-week="1"
                        />
                      </v-menu>
                    </v-flex>

                    <!-- Arrival  date -->
                    <v-flex xs12>
                      <v-menu
                        ref="contract_unloading_arrival_date"
                        :close-on-content-click="true"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <v-text-field
                          readonly
                          slot="activator"
                          :value="
                            contract_draft.contract_unloading_arrival_date
                              ? timeToDate(
                                  contract_draft.contract_unloading_arrival_date
                                )
                              : null
                          "
                          label="Unloading Arrival Date"
                        >
                          <template slot="label">
                            <v-icon size="14" class="pr-1" color="#757575"
                              >event</v-icon
                            >For Customer: Arrival Date
                          </template>
                        </v-text-field>
                        <v-date-picker
                          v-model="
                            contract_draft.contract_unloading_arrival_date
                          "
                          no-title
                          scrollable
                          first-day-of-week="1"
                        />
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-stepper-content>

            <v-stepper-content step="5">
              <template v-if="!loading">
                <!-- Step Title -->
                <v-flex xs12 class="pa-4 text-xs-center">
                  <span
                    v-if="isNewContract"
                    class="caption grey--text text--darken-1"
                  >
                    Please take a moment to
                    <strong>review the information below</strong> before
                    submitting the new contract.
                  </span>
                  <span
                    v-if="editContract"
                    class="caption grey--text text--darken-1"
                  >
                    Please take a moment to
                    <strong>review the information below</strong> before
                    updating the contract.
                  </span>
                </v-flex>

                <v-layout row wrap justify-center v-if="step == 5">
                  <v-flex
                    xs12
                    v-for="group in contractOverview"
                    :key="group[0]"
                  >
                    <v-flex xs12>
                      <v-subheader class="primary--text font-weight-bold">{{
                        group[0]
                      }}</v-subheader>

                      <v-layout
                        my-2
                        align-center
                        v-for="item in group[1]"
                        :key="item[0]"
                      >
                        <v-flex xs5 offset-xs1>
                          <span style="color: #757575">
                            <v-icon small class="pr-1" color="#757575">{{
                              item[2]
                            }}</v-icon
                            >{{ item[0] }}:
                          </span>
                        </v-flex>
                        <v-flex xs6>{{ item[1] }}</v-flex>
                      </v-layout>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </template>
              <v-layout
                style="height: 500px"
                column
                align-center
                class="text-xs-center"
                v-show="loading"
              >
                <v-spacer></v-spacer>
                <v-flex class="text-xs-center">
                  <breeding-rhombus-spinner
                    style="margin: auto"
                    class="text-xs-center"
                    :animation-duration="1000"
                    :size="80"
                    color="#1976d2"
                  />

                  <h3 class="primary--text pt-4">Submitting new contract</h3>
                  <v-label>Please wait a moment...</v-label>
                </v-flex>
                <v-spacer></v-spacer>
              </v-layout>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>

        <v-divider></v-divider>

        <!-- Actions Button ( Cancel Back Next) -->
        <v-card-actions v-if="isNewContract || editContract">
          <v-btn
            v-if="isNewContract"
            depressed
            small
            to="/contracts?tab=validatedContracts"
            flat
            color="red"
          >
            <v-icon small class="pr-2">close</v-icon>Cancel
          </v-btn>
          <v-btn
            v-if="editContract"
            depressed
            small
            @click="cancelContractEditing()"
            flat
            color="red"
          >
            <v-icon small class="pr-2">close</v-icon>Cancel
          </v-btn>
          <v-btn
            small
            color="grey darken-1"
            v-show="step != 1"
            flat
            @click="step--"
            depressed
          >
            <v-icon small class="pr-2">mdi-arrow-left</v-icon>Back
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            small
            v-show="step != 5"
            :disabled="!canClicOnNextStep"
            color="blue"
            class="white--text"
            @click="step++"
          >
            <v-icon small class="pr-2">mdi-arrow-right</v-icon>Next
          </v-btn>

          <v-btn
            depressed
            small
            v-show="step == 5 && isNewContract"
            color="amber darken-1"
            class="white--text"
            @click="createNewContract()"
            :disabled="loading"
          >
            <v-icon small class="pr-2">mdi-shield-check</v-icon>Create New
            Contract
          </v-btn>

          <v-btn
            depressed
            small
            v-show="editContract"
            :disabled="!canClicOnNextStep || loading"
            class="white--text"
            color="success"
            @click="updateContractSettings()"
          >
            <v-icon small class="pr-2">save</v-icon>Update Contract
          </v-btn>
        </v-card-actions>

        <v-card-actions v-if="!isNewContract && !editContract">
          <v-spacer></v-spacer>
          <v-btn
            depressed
            small
            v-show="step != 5 && !editContract"
            :disabled="!canClicOnNextStep"
            color="primary"
            @click="editContractToggle()"
          >
            <v-icon small class="pr-2">edit</v-icon>Edit Contract Settings
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
    <!-- <json-viewer :value="contractOverview" sort></json-viewer>    -->
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import date from "../../mixins/date.js";
import SUPPLIER_PREFILL from "../../graphql/contracts/supplier_prefill.gql";
import CUSTOMER_PREFILL from "../../graphql/contracts/customer_prefill.gql";
import CREATE_CONTRACT from "../../graphql/contracts/create.gql";
import UPDATE_CONTRACT from "../../graphql/contracts/update_settings.gql";
import { BreedingRhombusSpinner } from "epic-spinners";
import JsonViewer from "vue-json-viewer";
export default {
  mixins: [date],
  components: { JsonViewer, BreedingRhombusSpinner },
  props: {
    editedContract: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      loading_query: false,
      isNewContract: true,
      step: 1,
      editContract: false,
      queriesCompleted: 0,
      contract_draft: {
        contract_name: "",
        contract_date: new Date().toISOString().substr(0, 10),
        contract_score_currency_id: null,

        contract_buying_subsidiary_id: "",
        contract_buying_bank_information_id: "",

        contract_selling_subsidiary_id: "",
        contract_selling_bank_information_id: "",

        supplier_company_id: "",
        supplier: null,
        supplier_company_name: "",
        supplier_company_short_name: "",
        supplier_affiliate_id: "",
        supplier_currency_id: null,
        supplier_payment_term_id: "",
        supplier_incoterm_id: "",
        supplier_errors: [],
        contract_loading_port_id: "",
        contract_origin_country_id: "",

        customer_company_id: "",
        customer: null,
        customer_company_name: "",
        customer_company_short_name: "",
        customer_affilitate_id: "",
        customer_currency_id: null,
        customer_payment_term_id: "",
        customer_incoterm_id: "",
        customer_documentary_instruction_id: "",
        customer_logistic_auditor_id: "",
        customer_errors: [],
        contract_unloading_port_id: "",
        contract_destination_country_id: "",

        contract_loading_departure_date: new Date().toISOString().substr(0, 10),
        contract_loading_arrival_date: new Date().toISOString().substr(0, 10),
        contract_unloading_departure_date: new Date()
          .toISOString()
          .substr(0, 10),
        contract_unloading_arrival_date: new Date().toISOString().substr(0, 10),
      },
    };
  },
  computed: {
    ...mapGetters("commonStore", [
      "contracts",
      "currencies",
      "companies",
      "productsSupplierCompanies",
      "customers",
      "subsidiaries",
    ]),
    canClicOnNextStep() {
      if (this.step == 1) {
        if (
          !this.contract_draft.contract_name ||
          !this.contract_draft.contract_date ||
          !this.contract_draft.contract_score_currency_id
        )
          return false;
      }

      if (this.step == 3) {
        if (
          !this.contract_draft.supplier ||
          !this.contract_draft.customer ||
          this.contract_draft.supplier_errors.length ||
          this.contract_draft.customer_errors.length
        )
          return false;
      }

      if (this.step == 2) {
        if (
          !this.contract_draft.contract_buying_subsidiary_id ||
          !this.contract_draft.contract_selling_subsidiary_id ||
          !this.contract_draft.contract_selling_bank_information_id ||
          !this.contract_draft.contract_buying_bank_information_id
        )
          return false;
      }

      return true;
    },
    supplierAffiliateCompanies() {
      if (this.contract_draft.supplier_company_id) {
        return this.companies.find((company) => {
          return company.id === this.contract_draft.supplier_company_id;
        }).affiliate_companies;
      }

      return [];
    },
    supplierCompanyDisplayName() {
      if (
        this.contract_draft.supplier_affiliate_id &&
        this.supplierAffiliateCompanies.length
      ) {
        var supplier_affiliate = this.supplierAffiliateCompanies.find((ac) => {
          return ac.id == this.contract_draft.supplier_affiliate_id;
        });

        if (supplier_affiliate) {
          console.log(supplier_affiliate.name);
          return supplier_affiliate.name;
        }
      }
      return this.contract_draft.supplier_company_name;
    },
    customerAffiliateCompanies() {
      if (this.contract_draft.customer_company_id) {
        return this.companies.find((company) => {
          return company.id === this.contract_draft.customer_company_id;
        }).affiliate_companies;
      }

      return [];
    },
    buyingBankInformations() {
      if (this.contract_draft.contract_buying_subsidiary_id) {
        return this.subsidiaries.find(
          (s) => s.id == this.contract_draft.contract_buying_subsidiary_id
        ).subsidiary.bank_informations;
      }
      return [];
    },
    sellingBankInformations() {
      if (this.contract_draft.contract_selling_subsidiary_id) {
        return this.subsidiaries.find(
          (s) => s.id == this.contract_draft.contract_selling_subsidiary_id
        ).subsidiary.bank_informations;
      }
      return [];
    },
    contractOverview() {
      //group
      // name, variable, icon

      if (this.step == 5) {
        return [
          [
            "Subsidiaries",
            [
              [
                "Buying Subsidiary",
                this.subsidiaries.find(
                  (s) =>
                    s.id == this.contract_draft.contract_buying_subsidiary_id
                ).name,
                "mdi-store",
              ],
              [
                "Buying Bank",
                this.buyingBankInformations.find(
                  (b) =>
                    b.id ==
                    this.contract_draft.contract_buying_bank_information_id
                ).name,
                "mdi-bank-transfer-out",
              ],
              [
                "Selling Subsidiary",
                this.subsidiaries.find(
                  (s) =>
                    s.id == this.contract_draft.contract_selling_subsidiary_id
                ).name,
                "mdi-store",
              ],
              [
                "Selling Bank",
                this.sellingBankInformations.find(
                  (b) =>
                    b.id ==
                    this.contract_draft.contract_selling_bank_information_id
                ).name,
                "mdi-bank-transfer-in",
              ],
            ],
          ],
          [
            "Contract Settings",
            [
              [
                "Name",
                this.contract_draft.contract_name,
                "mdi-format-quote-close",
              ],
              [
                "Date",
                this.contract_draft.contract_date
                  ? this.timeToDate(this.contract_draft.contract_date)
                  : null,
                "event",
              ],
              [
                "Score Currency",
                this.currencies.find(
                  (c) => c.id == this.contract_draft.contract_score_currency_id
                ).code,
                "money",
              ],
            ],
          ],
          [
            "Product Supplier",
            [
              ["Name", this.contract_draft.supplier_company_name, "mdi-store"],
              [
                "Affiliate Company",
                this.contract_draft.supplier_affiliate_id
                  ? this.supplierAffiliateCompanies.find(
                      (a) => a.id == this.contract_draft.supplier_affiliate_id
                    ).name
                  : "",
                "mdi-store-outline",
              ],
              [
                "Currency",
                this.contract_draft.supplier.currencies.find(
                  (c) => c.id == this.contract_draft.supplier_currency_id
                ).code,
                "mdi-cash",
              ],
              [
                "Payment Terms",
                this.contract_draft.supplier.payment_terms.find(
                  (pt) => pt.id == this.contract_draft.supplier_payment_term_id
                ).name,
                "mdi-cash-check",
              ],
              [
                "Incoterms",
                this.contract_draft.supplier.incoterms.find(
                  (i) => i.id == this.contract_draft.supplier_incoterm_id
                ).name,
                "mdi-comment-check",
              ],
            ],
          ],
          [
            "Customer",
            [
              ["Name", this.contract_draft.customer_company_name, "mdi-store"],
              [
                "Affiliate Company",
                this.contract_draft.customer_affiliate_id
                  ? this.customerAffiliateCompanies.find(
                      (a) => a.id == this.contract_draft.customer_affiliate_id
                    ).name
                  : "",
                "mdi-store-outline",
              ],
              [
                "Currency",
                this.contract_draft.customer.currencies.find(
                  (c) => c.id == this.contract_draft.customer_currency_id
                ).code,
                "mdi-cash",
              ],
              [
                "Payment Terms",
                this.contract_draft.customer.payment_terms.find(
                  (pt) => pt.id == this.contract_draft.customer_payment_term_id
                ).name,
                "mdi-cash-check",
              ],
              [
                "Incoterms",
                this.contract_draft.customer.incoterms.find(
                  (i) => i.id == this.contract_draft.customer_incoterm_id
                ).name,
                "mdi-comment-check",
              ],
              [
                "Documentary Instructions",
                this.contract_draft.customer.documentary_instructions.find(
                  (di) =>
                    di.id ==
                    this.contract_draft.customer_documentary_instruction_id
                ).name,
                "mdi-text-box-check",
              ],
              [
                "Logistic Auditor",
                this.contract_draft.customer_logistic_auditor_id
                  ? this.contract_draft.customer.logistic_auditors.find(
                      (a) =>
                        a.id == this.contract_draft.customer_logistic_auditor_id
                    ).name
                  : "",
                "mdi-clipboard-search",
              ],
            ],
          ],
          [
            "Loading",
            [
              [
                "POL (Port Of Loading)",
                this.contract_draft.supplier.ports.find(
                  (p) => p.id == this.contract_draft.contract_loading_port_id
                ).name,
                "mdi-boom-gate-down-outline",
              ],
              [
                "Products Origin Country",
                this.contract_draft.supplier.countries.find(
                  (c) => c.id == this.contract_draft.contract_origin_country_id
                ).name,
                "mdi-flag",
              ],
              [
                "For Supplier: Departure Date",
                this.timeToDate(
                  this.contract_draft.contract_loading_departure_date
                ),
                "event",
              ],
              [
                "For Supplier: Arrival Date",
                this.timeToDate(
                  this.contract_draft.contract_loading_arrival_date
                ),
                "event",
              ],
            ],
          ],
          [
            "Unloading",
            [
              [
                "POU (Port Of Unloading)",
                this.contract_draft.customer.ports.find(
                  (p) => p.id == this.contract_draft.contract_unloading_port_id
                ).name,
                "mdi-boom-gate-down-outline",
              ],
              [
                "Products Destination Country",
                this.contract_draft.customer.countries.find(
                  (c) =>
                    c.id == this.contract_draft.contract_destination_country_id
                ).name,
                "mdi-flag",
              ],
              [
                "For Customer: Departure Date",
                this.timeToDate(
                  this.contract_draft.contract_unloading_departure_date
                ),
                "event",
              ],
              [
                "For Customer: Arrival Date",
                this.timeToDate(
                  this.contract_draft.contract_unloading_arrival_date
                ),
                "event",
              ],
            ],
          ],
        ];
      } else return [];
    },
    buyingSubsidiary() {
      if (this.contract_draft.contract_buying_subsidiary_id) {
        return this.companies.find(
          (c) => c.id == this.contract_draft.contract_buying_subsidiary_id
        );
      }
      return null;
    },
    sellingSubsidiary() {
      if (this.contract_draft.contract_selling_subsidiary_id) {
        return this.companies.find(
          (c) => c.id == this.contract_draft.contract_selling_subsidiary_id
        );
      }
      return null;
    },
    editedContractStatus() {
      // console.log(this.editedContract, this.isNewContract);
      if (!this.isNewContract) {
        if (this.editedContract.archived) return "archived";
        if (this.editedContract.status == "pending") return "pending";
        if (this.editedContract.status == "validated") return "validated";
      }
      return "unknown";
    },
    editedContractStatusIcon() {
      if (!this.isNewContract) {
        if (this.editedContract.archived) return "mdi-lock";
        if (this.editedContract.status == "pending")
          return " mdi-calendar-clock";
        if (this.editedContract.status == "validated") return "mdi-check-bold";
      }
      return "mdi-help";
    },
    editedContractStatusIconColor() {
      if (!this.isNewContract) {
        if (this.editedContract.archived) return "amber darken-1";
        if (this.editedContract.status == "pending") return "blue";
        if (this.editedContract.status == "validated") return "success";
      }
      return "white";
    },
  },
  methods: {
    resetSupplier() {
      this.contract_draft.supplier = null;
      this.contract_draft.supplier_company_name = "";
      this.contract_draft.supplier_company_short_name = "";
      this.contract_draft.supplier_affiliate_id = "";
      this.contract_draft.supplier_currency_id = null;
      this.contract_draft.supplier_payment_term_id = "";
      this.contract_draft.supplier_incoterm_id = "";
      this.contract_draft.supplier_errors = [];
      this.contract_draft.contract_loading_port_id = "";
      this.contract_draft.contract_origin_country_id = "";
    },
    resetCustomer() {
      this.contract_draft.customer = null;

      this.contract_draft.customer_company_name = "";
      this.contract_draft.customer_company_short_name = "";
      this.contract_draft.customer_affilitate_id = "";
      this.contract_draft.customer_currency_id = null;
      this.contract_draft.customer_payment_term_id = "";
      this.contract_draft.customer_incoterm_id = "";
      this.contract_draft.customer_documentary_instruction_id = "";
      this.contract_draft.customer_logistic_auditor_id = "";
      this.contract_draft.customer_errors = [];
      this.contract_draft.contract_unloading_port_id = "";
      this.contract_draft.contract_destination_country_id = "";
    },
    queryCompanyInfos(company_type) {
      //  company type is either "supplier" or "customer"

      let gql_file =
        company_type == "supplier" ? SUPPLIER_PREFILL : CUSTOMER_PREFILL;
      let company_id = this.contract_draft[
        company_type == "supplier"
          ? "supplier_company_id"
          : "customer_company_id"
      ];

      let company = this.companies.find((company) => {
        return company.id === company_id;
      });

      if (company_id) {
        this.sendQuery(gql_file, {
          id:
            company_type == "supplier"
              ? company.supplier.id
              : company.customer.id,
        })
          .then((data) => {
            if (!this.editContract) {
              this.queriesCompleted++;
              console.log("Queries completed: ", this.queriesCompleted);
              if (this.queriesCompleted == 2) {
                this.queriesCompleted = 0;
                this.loading_query = false;
                console.log("end of both queries");
              }
            }
            // console.log(
            //   "%c gql query: " + company_type,
            //   "background: #000; color: #bada55"
            // );

            if (company_type == "supplier") {
              this.resetSupplier();

              this.contract_draft.supplier = data.supplier;
              this.contract_draft.supplier_company_short_name = company.short_name
                ? company.short_name
                : company.name;

              this.contract_draft.supplier_company_name = company.name;

              if (this.contract_draft.supplier.shipping_companies.length == 0)
                this.contract_draft.supplier_errors.push(
                  "This supplier need at least one <b>Shipping Company</b>."
                );

              if (this.contract_draft.supplier.currencies.length)
                this.contract_draft.supplier_currency_id = this.contract_draft.supplier.currencies[0].id;
              else
                this.contract_draft.supplier_errors.push(
                  "This supplier need at least one <b>Currency</b>."
                );

              if (this.contract_draft.supplier.payment_terms.length)
                this.contract_draft.supplier_payment_term_id = this.contract_draft.supplier.payment_terms[0].id;
              else
                this.contract_draft.supplier_errors.push(
                  "This supplier need at least one <b>Payment Term</b>."
                );

              if (this.contract_draft.supplier.incoterms.length)
                this.contract_draft.supplier_incoterm_id = this.contract_draft.supplier.incoterms[0].id;
              else
                this.contract_draft.supplier_errors.push(
                  "This supplier need at least one <b>Incoterm</b>."
                );

              if (this.contract_draft.supplier.ports.length)
                this.contract_draft.contract_loading_port_id = this.contract_draft.supplier.ports[0].id;
              else
                this.contract_draft.supplier_errors.push(
                  "This supplier need at least one <b>Port of Loading</b>."
                );

              if (this.contract_draft.supplier.countries.length) {
                this.contract_draft.contract_origin_country_id = this.contract_draft.supplier.countries[0].id;
              } else
                this.contract_draft.supplier_errors.push(
                  "This supplier need at least one <b>Country Of Origin (products)</b>."
                );

              // console.log("end query supp");
              if (!this.isNewContract && !this.editContract)
                this.loadInfoFromEditedContract();
            }

            if (company_type == "customer") {
              this.resetCustomer();
              this.contract_draft.customer = data.customer;
              this.contract_draft.customer_company_short_name = company.short_name
                ? company.short_name
                : company.name;
              this.contract_draft.customer_company_name = company.name;

              if (this.contract_draft.customer.currencies.length)
                this.contract_draft.customer_currency_id = this.contract_draft.customer.currencies[0].id;
              else
                this.contract_draft.customer_errors.push(
                  "This customer need at least one <b>Currency</b>."
                );

              if (this.contract_draft.customer.payment_terms.length)
                this.contract_draft.customer_payment_term_id = this.contract_draft.customer.payment_terms[0].id;
              else
                this.contract_draft.customer_errors.push(
                  "This customer need at least one <b>Payment Term</b>."
                );

              if (this.contract_draft.customer.incoterms.length)
                this.contract_draft.customer_incoterm_id = this.contract_draft.customer.incoterms[0].id;
              else
                this.contract_draft.customer_errors.push(
                  "This customer need at least one <b>Incoterm</b>."
                );

              if (this.contract_draft.customer.documentary_instructions.length)
                this.contract_draft.customer_documentary_instruction_id = this.contract_draft.customer.documentary_instructions[0].id;
              else
                this.contract_draft.customer_errors.push(
                  "This customer need at least one <b>Documentary Instruction</b>."
                );

              if (this.contract_draft.customer.logistic_auditors.length)
                this.contract_draft.customer_logistic_auditor_id = this.contract_draft.customer.logistic_auditors[0].id;

              if (this.contract_draft.customer.ports.length)
                this.contract_draft.contract_unloading_port_id = this.contract_draft.customer.ports[0].id;
              else
                this.contract_draft.customer_errors.push(
                  "This customer need at least one <b>Port of Unloading</b>."
                );

              if (this.contract_draft.customer.countries.length)
                this.contract_draft.contract_destination_country_id = this.contract_draft.customer.countries[0].id;
              else
                this.contract_draft.customer_errors.push(
                  "This customer need at least one <b>Country Of Destination (products)</b>."
                );

              // console.log("end query customer");
              if (!this.isNewContract & !this.editContract)
                this.loadInfoFromEditedContract();
            }
          })
          .catch((e) => {
            this.queriesCompleted = 0;
          });
      }
    },
    updateContractSettings() {
      let old_step = this.step;
      if (this.step == 1) {
        if (
          !this.contract_draft.contract_name ||
          !this.contract_draft.contract_date ||
          !this.contract_draft.contract_score_currency_id
        )
          return false;
        this.step++;
      }

      if (this.step == 2) {
        if (
          !this.contract_draft.contract_buying_subsidiary_id ||
          !this.contract_draft.contract_selling_subsidiary_id ||
          !this.contract_draft.contract_selling_bank_information_id ||
          !this.contract_draft.contract_buying_bank_information_id
        )
          return false;
        this.step++;
      }

      if (this.step == 3) {
        if (
          !this.contract_draft.supplier ||
          !this.contract_draft.customer ||
          this.contract_draft.supplier_errors.length ||
          this.contract_draft.customer_errors.length
        )
          return false;
      }

      this.step = old_step;

      console.log("this.step", this.step);

      console.log(this.contract_draft);
      this.loading = true;
      this.contract_draft.id = this.editedContract.id;
      this.sendMutation(
        "no-notif",
        "contract",
        UPDATE_CONTRACT,
        this.contract_draft
      ).then((data) => {
        this.editContract = false;
        this.step = 1;
        this.loading = false;
        this.$emit("updateSettings");
      });
    },
    createNewContract() {
      this.loading = true;
      this.contract_draft.customer_logistic_auditor_ids = [
        this.contract_draft.customer_logistic_auditor_id,
      ];
      this.contract_draft.customer_parameter_ids = this.contract_draft.customer.customer_parameter_ids;
      this.contract_draft.additional_information_ids = this.contract_draft.supplier.additional_information_ids;
      this.sendMutation(
        "created",
        "contract",
        CREATE_CONTRACT,
        this.contract_draft
      ).then((data) => {
        this.$emit("contract_created", data.create_contract.id);

        // this.$router.push({
        //   name: "contract",
        //   params: { id: data.create_contract.id },
        // });
      });
    },
    loadInfoFromEditedContract() {
      // Contract
      this.contract_draft.contract_name = this.editedContract.name;
      this.contract_draft.contract_date = this.editedContract.date;
      this.contract_draft.contract_score_currency_id = this.editedContract.score_currency_id;
      this.contract_draft.contract_buying_subsidiary_id = this.editedContract.buying_company_id;
      this.contract_draft.contract_buying_bank_information_id = this.editedContract.buying_bank_information_id;
      this.contract_draft.contract_selling_subsidiary_id = this.editedContract.selling_company_id;
      this.contract_draft.contract_selling_bank_information_id = this.editedContract.selling_bank_information_id;

      // Supplier
      this.contract_draft.supplier_affiliate_id = this.editedContract.supplier_affiliate_company_id;

      this.contract_draft.supplier_currency_id = this.editedContract.supplier_currency_id;
      this.contract_draft.supplier_payment_term_id = this.editedContract.supplier_payment_term_id;
      this.contract_draft.supplier_incoterm_id = this.editedContract.supplier_incoterm_id;

      // Customer
      this.contract_draft.customer_affilitate_id = this.editedContract.customer_affiliate_company_id;
      this.contract_draft.customer_currency_id = this.editedContract.customer_currency_id;
      this.contract_draft.customer_payment_term_id = this.editedContract.customer_payment_term_id;
      this.contract_draft.customer_incoterm_id = this.editedContract.customer_incoterm_id;
      this.contract_draft.customer_documentary_instruction_id = this.editedContract.documentary_instruction_id;

      if (this.editedContract.logistic_auditor_ids.length > 0) {
        this.contract_draft.customer_logistic_auditor_id = this.editedContract.logistic_auditor_ids[0];
      }

      // Loading / Unloading
      this.contract_draft.contract_loading_port_id = this.editedContract.loading_port_id;
      this.contract_draft.contract_origin_country_id = this.editedContract.origin_country_id;
      this.contract_draft.contract_unloading_port_id = this.editedContract.unloading_port_id;
      this.contract_draft.contract_destination_country_id = this.editedContract.destination_country_id;

      this.contract_draft.contract_loading_departure_date = this.editedContract.loading_departure_date;
      this.contract_draft.contract_loading_arrival_date = this.editedContract.loading_arrival_date;
      this.contract_draft.contract_unloading_departure_date = this.editedContract.unloading_departure_date;
      this.contract_draft.contract_unloading_arrival_date = this.editedContract.unloading_arrival_date;
    },
    editContractToggle() {
      this.editContract = true;
      this.step = 1;
    },
    cancelContractEditing() {
      this.editContract = false;
      this.step = 1;
      this.querySupplierAndCustomer();
    },
    createComponentEvent() {
      if (this.editedContract != null) {
        this.isNewContract = false;
      }

      if (this.isNewContract == true) {
        this.resetSupplier();
        this.resetCustomer();

        const year = new Date().getFullYear().toString();

        if (this.contracts[0])
          this.contract_draft.contract_name =
            year +
            " / " +
            (parseInt(this.contracts[0].name.split(" / ")[1]) + 1).toString();
      } else this.querySupplierAndCustomer();
    },
    querySupplierAndCustomer() {
      console.log("Starting Both queries");
      this.loading_query = true;
      this.contract_draft.supplier_company_id = this.editedContract.supplier_company_id;
      this.contract_draft.customer_company_id = this.editedContract.customer_company_id;

      //Query Supplier and Customer needed data
      this.queriesCompleted = 0;
      this.queryCompanyInfos("supplier");
      this.queryCompanyInfos("customer");
    },
  },
  created() {
    this.createComponentEvent();
  },
  beforeDestroy() {},
};
</script>

<style>
</style>
